<template>
  <div>
    <template v-if="template === 'edit' || typeof template === 'undefined'">
      <label :class="labelClass ? labelClass : 'u-label'">
        {{ field.label + (field.required ? '* ' : '') }}
      </label>
      <div class="c-currency-field">
        <div class="c-currency-field__currency-icon">
          <i class="fa fa-usd"></i>
        </div>
        <input
          v-if        = "!field.readonly"
          :class      = "'qa-' + field.name + '__input'"
          :value      = "value"
          @input      = "update($event.target)"
          ref         = "input"
          type        = "number"
          min         = "0.00"
          max         = "99999999.99"
          step        = "0.01"
          placeholder = "0.00"
        />

        <input
          v-if        = "field.readonly"
          :class      = "'qa-' + field.name + '__input'"
          :value      = "value"
          ref         = "input"
          type        = "number"
          min         = "0.00"
          max         = "99999999.99"
          step        = "0.01"
          placeholder = "0.00"
          readonly    = "readonly"
          disabled    = "disabled"
        />
      </div>
    </template>
    <template v-if="template === 'detail'">
      <label :class="labelClass ? labelClass : 'u-label'">
        {{ field.label + (field.required ? '* ' : '') }}
      </label>
      <p
        class  = "u-paragraph"
        :class = "'qa-' + field.name + '__value'"
      >
        {{ formatUSD }}
      </p>
    </template>
  </div>
</template>


<script>
import $ from 'jquery'

export default {
  props: ['field', 'value', 'labelClass', 'template'],

  computed: {
    formatUSD () {
      // Uses a js constructer to nicely handle formatting US currency
      return Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
      }).format(this.value)
    }
  },

  methods: {
    update (target) {
      // using valueAsNumber might clear the input in IE on invalid values
      let value = $(target)[0].value
      this.$emit('input', value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// FieldCurrency.vue?6e814800